"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const galleryImagesComponent_1 = __importDefault(require("../../../../components/galleryImagesComponent/galleryImagesComponent"));
require("./GalleryImages.scss");
const GalleryImagesStyles_1 = require("./GalleryImagesStyles");
const GalleryMockData_1 = __importDefault(require("./GalleryMockData"));
const GalleryImages = ({ title, close, imagesList = GalleryMockData_1.default }) => {
    return (react_1.default.createElement("div", { className: "modalOpened" },
        react_1.default.createElement(GalleryImagesStyles_1.CloseButton, { onClick: close }, "X"),
        react_1.default.createElement(GalleryImagesStyles_1.Container, null,
            react_1.default.createElement(GalleryImagesStyles_1.ImageTitle, null,
                "Edif\u00EDcio \u00A0",
                react_1.default.createElement("span", null, title)),
            react_1.default.createElement(galleryImagesComponent_1.default, { imagesList: imagesList.length !== 0 ? imagesList : GalleryMockData_1.default, title: title, showGalleryScroll: true }))));
};
exports.default = GalleryImages;
